import { jsxs as m, jsx as o } from "react/jsx-runtime";
import { forwardRef as v, useState as I, useEffect as j } from "react";
import { tv as C } from "tailwind-variants";
const p = C({
  slots: {
    wrapper: ["flex", "gap-4", "items-center"],
    toggleButton: [
      "bg-neutral-300",
      "cursor-pointer",
      "peer-checked:bg-blue-500",
      "peer-focus:outline",
      "peer-focus:outline-dotted",
      "peer-focus:outline-offset-1",
      "peer-focus:outline-cyan-500",
      "peer-focus:outline-[3px]",
      "relative",
      "rounded-full",
      "transition-colors"
    ],
    toggleCircle: [
      "absolute",
      "aspect-square",
      "bg-white",
      "rounded-full",
      "transition-transform"
    ]
  },
  variants: {
    disabled: {
      true: {
        toggleButton: ["cursor-not-allowed"]
      }
    },
    size: {
      sm: {
        toggleButton: [
          "h-[1.375rem]",
          "peer-checked:*:translate-x-[1rem]",
          "w-[2.5rem]"
        ],
        toggleCircle: ["left-[0.25rem]", "top-[0.175rem]", "w-[1rem]"]
      },
      md: {
        toggleButton: [
          "h-[1.8rem]",
          "peer-checked:*:translate-x-[1.3rem]",
          "w-[3.3rem]"
        ],
        toggleCircle: ["left-[0.35rem]", "top-[0.25rem]", "w-[1.3rem]"]
      }
    }
  }
}), { wrapper: S, toggleButton: T, toggleCircle: q } = p(), f = v(
  ({
    ariaDescribedby: g,
    ariaLabel: b,
    checked: e,
    defaultChecked: y,
    disabled: r,
    name: x,
    onChange: a,
    offLabel: i,
    onLabel: u,
    size: c = "md",
    toggleButtonClassName: w,
    toggleCircleClassName: h,
    wrapperClassName: N,
    value: n
  }, B) => {
    const [l, d] = I(y || !1), s = (t) => {
      t !== l && (e === void 0 && d(t), a == null || a(n ? t ? n : null : t));
    };
    return j(() => {
      e !== void 0 && e !== l && d(e);
    }, [e]), /* @__PURE__ */ m("div", { className: S({ class: N }), ref: B, children: [
      i && /* @__PURE__ */ o(
        "button",
        {
          "aria-hidden": !0,
          className: "font-secondary font-semibold",
          disabled: r,
          onClick: () => s(u ? !1 : !e),
          tabIndex: "-1",
          type: "button",
          children: i
        }
      ),
      /* @__PURE__ */ m("div", { className: "flex", children: [
        /* @__PURE__ */ o(
          "input",
          {
            "aria-describedby": g,
            "aria-label": b,
            "aria-live": "polite",
            checked: l,
            className: "peer sr-only",
            disabled: r,
            name: x,
            onChange: (t) => s(t.target.checked),
            role: "switch",
            type: "checkbox",
            value: typeof n == "string" ? n : void 0
          }
        ),
        /* @__PURE__ */ o(
          "button",
          {
            "aria-hidden": !0,
            className: T({
              class: w,
              disabled: r,
              size: c
            }),
            "data-testid": "toggleButton",
            disabled: r,
            onClick: () => s(!l),
            tabIndex: "-1",
            type: "button",
            children: /* @__PURE__ */ o(
              "div",
              {
                className: q({ class: h, size: c })
              }
            )
          }
        )
      ] }),
      u && /* @__PURE__ */ o(
        "button",
        {
          "aria-hidden": !0,
          className: "font-secondary font-semibold",
          disabled: r,
          onClick: () => s(i ? !0 : !e),
          tabIndex: "-1",
          type: "button",
          children: u
        }
      )
    ] });
  }
);
f.displayName = "ToggleInput";
f.styles = p;
export {
  f as default
};
